import { useState } from "react"
import { collection, addDoc } from "firebase/firestore"
import { db } from "../../services/firebase"
import { useAuth } from "../../context/AuthContext"

const CLOUD_NAME    = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME
const UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET

export default function SubirVoucher({ clienteId, clienteNombre, onSubido }) {
  const { user } = useAuth()
  const [archivo, setArchivo]         = useState(null)
  const [titulo, setTitulo]           = useState("")
  const [tipo, setTipo]               = useState("voucher_vuelo")
  const [validoHasta, setValidoHasta] = useState("")
  const [subiendo, setSubiendo]       = useState(false)
  const [error, setError]             = useState("")
  const [exito, setExito]             = useState(false)

  const tiposDoc = [
    { value: "voucher_vuelo",    label: "Voucher de vuelo"    },
    { value: "voucher_hotel",    label: "Voucher de hotel"    },
    { value: "seguro_viaje",     label: "Seguro de viaje"     },
    { value: "comprobante_pago", label: "Comprobante de pago" },
    { value: "otro",             label: "Otro documento"      },
  ]

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    background: "#1a1a1a",
    border: "1px solid #3a3a3a",
    borderRadius: "8px",
    color: "#e5e7eb",
    fontFamily: "Inter, sans-serif",
    fontSize: "0.9rem",
    outline: "none"
  }

  const labelStyle = {
    display: "block",
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#6b7280",
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  }

  async function handleSubir() {
    if (!archivo) return setError("Selecciona un archivo PDF.")
    if (!titulo)  return setError("Ingresa un titulo para el documento.")

    setError("")
    setSubiendo(true)

    try {
      const formData = new FormData()
      formData.append("file", archivo)
      formData.append("upload_preset", UPLOAD_PRESET)
      formData.append("folder", "lowtravel/vouchers/" + clienteId)

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/" + CLOUD_NAME + "/auto/upload",
        { method: "POST", body: formData }
      )

      if (!res.ok) throw new Error("Error al subir a Cloudinary")
      const data = await res.json()

      await addDoc(
        collection(db, "usuarios_sheets", clienteId, "vouchers"),
        {
          titulo:       titulo,
          tipo:         tipo,
          url_storage:  data.secure_url,
          valido_hasta: validoHasta || "Sin vencimiento",
          subido_por:   user?.email,
          subido_en:    new Date(),
        }
      )

      setExito(true)
      setArchivo(null)
      setTitulo("")
      setValidoHasta("")
      if (onSubido) onSubido()

    } catch (e) {
      console.error(e)
      setError("Error al subir el archivo. Intenta de nuevo.")
    } finally {
      setSubiendo(false)
    }
  }

  if (exito) {
    return (
      <div style={{ padding: "20px", background: "#0a2a1a", border: "1px solid #10b98140", borderRadius: "10px", textAlign: "center", color: "#10b981" }}>
        <div style={{ fontSize: "2rem", marginBottom: "8px" }}>✓</div>
        <div style={{ fontWeight: 700, marginBottom: "12px" }}>Documento subido correctamente</div>
        <button
          onClick={() => setExito(false)}
          style={{ padding: "8px 16px", background: "#10b98120", border: "1px solid #10b98140", borderRadius: "6px", color: "#10b981", cursor: "pointer", fontFamily: "Inter, sans-serif", fontWeight: 600 }}
        >
          Subir otro
        </button>
      </div>
    )
  }

  return (
    <div style={{ background: "#0f0f0f", border: "1px solid #2a2a2a", borderRadius: "12px", padding: "24px" }}>
      <div style={{ fontSize: "1rem", fontWeight: 700, color: "#e5e7eb", marginBottom: "20px", paddingBottom: "14px", borderBottom: "1px solid #2a2a2a" }}>
        Subir documento para {clienteNombre}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>

        <div>
          <label style={labelStyle}>Titulo del documento</label>
          <input type="text" placeholder="Ej: Voucher vuelo Buenos Aires - Cancun" value={titulo} onChange={e => setTitulo(e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Tipo de documento</label>
          <select value={tipo} onChange={e => setTipo(e.target.value)} style={inputStyle}>
            {tiposDoc.map(t => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={labelStyle}>Valido hasta (opcional)</label>
          <input type="date" value={validoHasta} onChange={e => setValidoHasta(e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Archivo PDF</label>
          <label style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px", padding: "32px", background: "#1a1a1a", border: "2px dashed " + (archivo ? "#10b981" : "#3a3a3a"), borderRadius: "10px", cursor: "pointer" }}>
            <span style={{ fontSize: "2rem" }}>{archivo ? "✓" : "📄"}</span>
            <span style={{ color: archivo ? "#10b981" : "#6b7280", fontWeight: 600, fontSize: "0.875rem" }}>
              {archivo ? archivo.name : "Hacer clic para seleccionar PDF o imagen"}
            </span>
            <span style={{ color: "#4b5563", fontSize: "0.8rem" }}>Maximo 500KB</span>
            <input
              type="file"
              accept=".pdf,image/*"
              style={{ display: "none" }}
              onChange={e => {
                const f = e.target.files[0]
                if (f && f.size > 500 * 1024) { setError("El archivo supera los 500KB."); return }
                setError("")
                setArchivo(f || null)
              }}
            />
          </label>
        </div>

        {error && (
          <div style={{ padding: "10px 14px", background: "#2a0a0a", border: "1px solid #ef444440", borderRadius: "8px", color: "#ef4444", fontSize: "0.875rem" }}>
            {error}
          </div>
        )}

        <button
          onClick={handleSubir}
          disabled={subiendo}
          style={{ padding: "12px", background: subiendo ? "#1a1a1a" : "#3b82f6", border: "none", borderRadius: "8px", color: subiendo ? "#6b7280" : "white", fontFamily: "Inter, sans-serif", fontSize: "0.95rem", fontWeight: 700, cursor: subiendo ? "not-allowed" : "pointer" }}
        >
          {subiendo ? "Subiendo..." : "Subir documento"}
        </button>

      </div>
    </div>
  )
}